module.exports = __webpack_public_path__ + "static/media/iPhone14_2.e25d80c5.png";